export const WIDGET_ID = 'broadcastWidget';
export const PACKAGE_NAME = 'jiraHomeBroadcastWidget';
export const TEAM_NAME = 'gravity';
export const DISMISS_ERROR_FLAG_ID = 'dismissErrorFlagId';
export const ON_DISMISS_ERROR = 'jiraHomeBroadcastOnDismissError';
export const ON_DISMISS_MUTATION_ERROR = 'jiraHomeBroadcastOnDismissMutationError';
export const JIRA_SOFTWARE_UPGRADE_TO_PREMIUM =
	'/admin/billing/applications/change-edition/jira-software.ondemand';
